


































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

type ScoreOption = {
  score: number;
  label: string;
};

type ScoreQuestion = {
  id: string;
  title: string;
  options: ScoreOption[];
};

@Component
export default class ZhuanbingScale extends Vue {
  @Prop({ default: () => ({}) })
  private initialAnswers!: Record<string, number | null>;

  private questions: ScoreQuestion[] = [
    {
      id: "kesu",
      title: "是否有咳嗽？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "偶尔" },
        { score: 4, label: "经常，对日常生活有一定影响" },
        { score: 6, label: "持续，严重影响日常生活" },
      ],
    },
    {
      id: "shenpi",
      title: "是否有神疲乏力？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "精神不振，尚能从事体力活动" },
        { score: 4, label: "精神疲倦，四肢乏力，勉强从事日常活动" },
        { score: 6, label: "精神极度疲乏，周身无力，无日常活动能力" },
      ],
    },
    {
      id: "nadai",
      title: "是否有纳呆？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "食欲较差，食量减少1/3" },
        { score: 4, label: "食欲不佳，食量减少1/2" },
        { score: 6, label: "终日不想进食，食量减少2/3" },
      ],
    },
    {
      id: "weihan",
      title: "是否有畏寒肢冷？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "偶尔" },
        { score: 4, label: "经常" },
        { score: 6, label: "持续" },
      ],
    },
    {
      id: "yaoxi",
      title: "是否有腰膝酸软？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "偶尔" },
        { score: 4, label: "经常" },
        { score: 6, label: "持续" },
      ],
    },
    {
      id: "wugengxiexie",
      title: "是否有五更泄泻？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "偶尔" },
        { score: 4, label: "经常" },
        { score: 6, label: "持续" },
      ],
    },
    {
      id: "shiyubuzhen",
      title: "是否有食欲不振？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "食欲较差，食量减少1/3" },
        { score: 4, label: "食欲不佳，食量减少1/2" },
        { score: 6, label: "终日不想进食，食量减少2/3" },
      ],
    },
    {
      id: "xiaobian",
      title: "是否有小便频数？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "偶尔" },
        { score: 4, label: "经常" },
        { score: 6, label: "持续" },
      ],
    },
    {
      id: "outu",
      title: "是否有呕吐？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "能忍受，不治可自行好转" },
        { score: 4, label: "食后即吐，难以进食" },
        { score: 6, label: "剧烈，甚至呕吐黄水" },
      ],
    },
    {
      id: "kaposhi",
      title: "是否有卡波氏肉瘤？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "局限于皮肤，有1-2处" },
        { score: 4, label: "局限于皮肤，多处" },
        { score: 6, label: "多处，且皮肤及粘膜均可见" },
      ],
    },
    {
      id: "linbajie",
      title: "是否有淋巴结肿大？",
      options: [
        { score: 0, label: "无" },
        { score: 2, label: "1处以上肿大，大于0.5cm" },
        { score: 4, label: "2处以上肿大，大于1cm" },
        { score: 6, label: "多处肿大，大于2cm" },
      ],
    },
  ];

  private answers: Record<string, number | null> = {};

  private created() {
    this.applyInitialAnswers();
  }

  @Watch("initialAnswers", { immediate: false, deep: true })
  private onInitialAnswersChange() {
    this.applyInitialAnswers();
  }

  private get answeredCount(): number {
    let count = 0;
    this.questions.forEach((q) => {
      if (this.answers[q.id] !== null) {
        count += 1;
      }
    });
    return count;
  }

  private get totalScore(): number {
    let score = 0;
    this.questions.forEach((q) => {
      const val = this.answers[q.id];
      if (typeof val === "number") {
        score += val;
      }
    });
    return score;
  }

  private get maxScore(): number {
    return this.questions.length * 6;
  }

  private choose(questionId: string, score: number) {
    this.$set(this.answers, questionId, score);
    this.$emit("score-change", this.totalScore);
    this.$emit("answers-change", { ...this.answers });
  }

  private resetAll() {
    const nextAnswers: Record<string, number | null> = {};
    this.questions.forEach((q) => {
      nextAnswers[q.id] = null;
    });
    this.answers = nextAnswers;
    this.$emit("score-change", 0);
    this.$emit("answers-change", { ...this.answers });
  }

  private applyInitialAnswers() {
    const nextAnswers: Record<string, number | null> = {};
    this.questions.forEach((q) => {
      const val = this.initialAnswers ? this.initialAnswers[q.id] : null;
      nextAnswers[q.id] = typeof val === "number" ? val : null;
    });
    this.answers = nextAnswers;
    this.$emit("score-change", this.totalScore);
    this.$emit("answers-change", { ...this.answers });
  }
}
